import { render, staticRenderFns } from "./supplys.vue?vue&type=template&id=dddac65c&scoped=true"
import script from "./supplys.vue?vue&type=script&lang=js"
export * from "./supplys.vue?vue&type=script&lang=js"
import style0 from "./supplys.vue?vue&type=style&index=0&id=dddac65c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddac65c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dddac65c')) {
      api.createRecord('dddac65c', component.options)
    } else {
      api.reload('dddac65c', component.options)
    }
    module.hot.accept("./supplys.vue?vue&type=template&id=dddac65c&scoped=true", function () {
      api.rerender('dddac65c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/terminal_info/form/components/supplys.vue"
export default component.exports